/* eslint-disable no-console */
/* eslint-disable no-alert */
/* eslint-disable indent */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

import backgroundImage from "../assets/images/1.jpg";
import locationGif from "../assets/images/17905792.jpg";
import emailGif from "../assets/images/11237480.jpg";

const labelStyle = {
  display: "block",
  fontWeight: 500,
  marginBottom: 4,
  color: "#444",
  fontSize: 15,
  letterSpacing: 0.2,
};

const inputStyle = {
  width: "100%",
  padding: "8px 0",
  border: "none",
  borderBottom: "1px solid #bbb",
  fontSize: 15,
  outline: "none",
  background: "transparent",
};

const checkboxBoxStyle = {
  border: "1px solid #bbb",
  borderRadius: 6,
  padding: "10px 18px",
  minWidth: 120,
  fontSize: 15,
  fontWeight: 500,
  display: "flex",
  alignItems: "center",
  gap: 8,
  background: "#fafafa",
};

const BoxStyle = {
  transition: "transform 0.3s ease, box-shadow 0.3s ease",
};

const BoxHover = {
  transform: "translateY(-8px)",
  boxShadow: "0 8px 20px rgba(0, 0, 0, 0.2)",
  border: "1px solid rgb(25, 111, 141)",
};

function DiscussForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    role_company: false,
    role_director: false,
    message: "",
    learn_search: false,
    learn_referral: false,
    learn_news: false,
    learn_social: false,
    learn_other: false,
  });

  const [hoveredBox, setHoveredBox] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const {
      name,
      value,
      type,
      checked,
    } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!formData.name.trim()
      || !formData.email.trim() || !formData.company.trim() || !formData.message.trim()) {
      alert("Please complete required fields.");
      return;
    }

    if (!formData.role_company && !formData.role_director) {
      alert("Please select your role.");
      return;
    }

    setSubmitting(true);
    try {
      const sheetData = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        company: formData.company,
        selectedRole: formData.role_company ? "Company" : "Independent Director",
        message: formData.message,
        howDidTheyReach: [
          formData.learn_search && "Search",
          formData.learn_referral && "Referral",
          formData.learn_news && "News",
          formData.learn_social && "Social Media",
          formData.learn_other && "Other",
        ].filter(Boolean).join(", "),
        page_url: window.location.href,
      };

      await fetch(
        "https://script.google.com/macros/s/AKfycbwwESo_0lr2Eh3JC_JadZgwu4YcN4ZsFZmodJTTvQVj5Rq0dNMj3ThNBNGYhoFEAJIYAg/exec",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          mode: "no-cors", // Note: no-cors will suppress response data
          body: JSON.stringify(sheetData),
        },
      );

      const submissionData = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        company: formData.company,
        message: formData.message,
        type: formData.role_company ? "Company" : "Independent Director",
        page_url: window.location.href,
        formt: "ctform",
      };

      const response = await fetch("https://cfobridge.com/insertcontactguvrn", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(submissionData),
      });

      const text = await response.text();
      console.log("Raw PHP response:", text); // Debug log

      try {
        const result = JSON.parse(text);
        if (response.ok && result.status) {
          alert("Form submitted successfully!");
        } else {
          alert(`PHP backend error: ${result.msg}`);
        }
      } catch (parseError) {
        console.error("Failed to parse PHP JSON:", parseError);
        console.error("Server response:", text);
        alert("PHP Server error: Unexpected response format.");
      }
      alert("Form submitted successfully!");

      // Reset form
      setFormData({
        name: "",
        email: "",
        phone: "",
        company: "",
        role_company: false,
        role_director: false,
        message: "",
        learn_search: false,
        learn_referral: false,
        learn_news: false,
        learn_social: false,
        learn_other: false,
      });
    } catch (err) {
      console.error("Form submission error:", err);
      alert("Something went wrong!");
    } finally {
      setSubmitting(false);
    }
  };

  const handleMouseEnter = (id) => setHoveredBox(id);
  const handleMouseLeave = () => setHoveredBox(null);

  const getBoxStyle = (id) => ({
    ...BoxStyle,
    flex: 1,
    minWidth: "280px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: 20,
    border: "1px solid rgb(145, 145, 145)",
    borderRadius: 12,
    padding: "16px",
    boxSizing: "border-box",
    ...(hoveredBox === id ? BoxHover : {}),
  });

  const handleMouseEnterButton = (e) => {
    e.target.style.backgroundColor = "#145a75";
  };

  const handleMouseLeaveButton = (e) => {
    e.target.style.backgroundColor = "#196f8d";
  };

  // Handle role selection (only one can be selected)
  const handleRoleChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      role_company: name === "role_company" ? checked : false,
      role_director: name === "role_director" ? checked : false,
    }));
  };

  return (
    <div style={{ background: "#fff", minHeight: "100vh" }}>
      {/* Main Contact Row */}
      <div
        className="contact-main-row"
        style={{
          maxWidth: "100%",
          display: "flex",
          flexWrap: "wrap",
          alignItems: "stretch",
          margin: "35px 10%",
        }}
      >
        {/* Left Column (Form) */}
        <div
          style={{
            flex: 1,
            minWidth: "300px",
            padding: "60px 40px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            background: "rgb(249 249 249)",
            borderRadius: "30px 0px 0 30px",
          }}
        >
          <h2 style={{ color: "#333", marginBottom: 30, fontSize: 28 }}>
            Get In Touch
          </h2>

          <form onSubmit={handleSubmit}>
            <input type="hidden" name="page_url" value={window.location.href} />

            <div style={{ marginBottom: 22 }}>
              <label htmlFor="contact-name" style={labelStyle}>
                Name*
              </label>
              <input
                id="contact-name"
                name="name"
                style={inputStyle}
                type="text"
                value={formData.name}
                onChange={handleInputChange}
                required
              />
            </div>

            <div style={{ marginBottom: 22 }}>
              <label htmlFor="contact-email" style={labelStyle}>
                Email*
              </label>
              <input
                id="contact-email"
                name="email"
                style={inputStyle}
                type="email"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
            </div>

            <div style={{ marginBottom: 22 }}>
              <label htmlFor="contact-phone" style={labelStyle}>
                Phone
              </label>
              <PhoneInput
                international
                defaultCountry="IN"
                placeholder="Enter phone number"
                value={formData.phone}
                onChange={(value) => setFormData((prev) => ({ ...prev, phone: value || "" }))}
                style={{
                  ...inputStyle,
                  background: "rgb(249 249 249)",
                }}
              />
            </div>

            <div style={{ marginBottom: 22 }}>
              <label htmlFor="contact-company" style={labelStyle}>
                Company*
              </label>
              <input
                id="contact-company"
                name="company"
                style={inputStyle}
                type="text"
                value={formData.company}
                onChange={handleInputChange}
                required
              />
            </div>

            <div style={{ marginBottom: 8 }}>
              <span style={{ ...labelStyle, marginBottom: 8 }}>
                SELECT YOUR ROLE*
              </span>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 12,
                  marginBottom: 4,
                }}
              >
                <div style={checkboxBoxStyle}>
                  <input
                    id="role-company"
                    name="role_company"
                    type="checkbox"
                    checked={formData.role_company}
                    onChange={handleRoleChange}
                  />
                  <label htmlFor="role-company">Company</label>
                </div>
                <div style={checkboxBoxStyle}>
                  <input
                    id="role-director"
                    name="role_director"
                    type="checkbox"
                    checked={formData.role_director}
                    onChange={handleRoleChange}
                  />
                  <label htmlFor="role-director">Independent Director</label>
                </div>
              </div>
              <div style={{ fontSize: 12, color: "#888" }}>
                Please select one of the above
              </div>
            </div>

            <div style={{ marginBottom: 22 }}>
              <label htmlFor="contact-message" style={labelStyle}>
                Message*
              </label>
              <textarea
                id="contact-message"
                name="message"
                style={{
                  ...inputStyle,
                  minHeight: 60,
                  resize: "vertical",
                  background: "rgb(249 249 249)",
                }}
                value={formData.message}
                onChange={handleInputChange}
                required
              />
            </div>

            <div style={{ marginBottom: 22 }}>
              <span style={labelStyle}>
                HOW DID YOU LEARN ABOUT US?
                <br />
                <span>Select all that apply</span>
              </span>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: 8,
                  marginTop: 8,
                }}
              >
                {[
                  ["learn_search", "General internet search"],
                  ["learn_referral", "Personal referral"],
                  ["learn_news", "News story or blog post"],
                  ["learn_social", "LinkedIn / social media"],
                  ["learn_other", "Other"],
                ].map(([id, label]) => (
                  <div key={id}>
                    <input
                      id={id}
                      name={id}
                      type="checkbox"
                      checked={formData[id]}
                      onChange={handleInputChange}
                    />
                    <label htmlFor={id} style={{ paddingLeft: 10 }}>
                      {label}
                    </label>
                  </div>
                ))}
              </div>
            </div>

            <button
              type="submit"
              disabled={submitting}
              style={{
                background: "#196f8d",
                color: "#fff",
                border: "none",
                borderRadius: 20,
                padding: "10px 32px",
                fontWeight: 600,
                fontSize: 16,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: 6,
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={handleMouseEnterButton}
              onMouseLeave={handleMouseLeaveButton}
            >
              SUBMIT
            </button>
          </form>
        </div>

        {/* Right Column (Image) */}
        <div
          className="contact-image-col"
          style={{
            flex: 1,
            minWidth: 320,
            background: `url(${backgroundImage}) center center/cover no-repeat`,
            borderRadius: "0px 30px 30px 0px",
          }}
        />
      </div>

      {/* Contact Details Boxes */}
      <div
        style={{
          maxWidth: "100%",
          margin: "40px auto",
          marginBottom: 0,
          display: "flex",
          flexWrap: "wrap",
          gap: 15,
          justifyContent: "center",
          padding: "0 10%",
        }}
      >
        {[
          {
            id: 1,
            img: locationGif,
            title: "Location",
            content: (
              <>AWFIS, 10th Floor,<br />R-city Mall, LBS Marg,
                <br />Ghatkopar West,<br />Mumbai, 400086</>
            ),
          },
          {
            id: 2,
            img: emailGif,
            title: "Email",
            content: (
              <>
                <div style={{ marginBottom: 8, fontSize: 15 }}>
                  <strong>General Inquires</strong><br />
                  <a href="mailto:info@guvrn.com" style={{ color: "#222" }}>info@guvrn.com</a>
                </div>
                <div style={{ fontSize: 15 }}>
                  <strong>Partnership With Us</strong><br />
                  <a href="mailto:partnership@guvrn.com" style={{ color: "#222" }}>partnership@guvrn.com</a>
                </div>
              </>
            ),
          },
        ].map(({
          id,
          img,
          title,
          content,
        }) => (
          <div
            key={id}
            style={getBoxStyle(id)}
            onMouseEnter={() => handleMouseEnter(id)}
            onMouseLeave={handleMouseLeave}
          >
            <img src={img} alt={title} style={{ width: 60, height: 60 }} />
            <div>
              <h2 style={{ color: "#333", marginBottom: 4, fontSize: 24 }}>
                {title}
              </h2>
              <div style={{ color: "#222", fontSize: 15, lineHeight: 1.6 }}>
                {content}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Google Map Responsive */}
      <div style={{ padding: "35px 10%" }}>
        <div style={{ borderRadius: 12, overflow: "hidden" }}>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3770.172312692462!2d72.91425347507699!3d19.10009518210943!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c732fb7bbe87%3A0x8c4972b7b74d2ef3!2sAwfis%20RCity!5e0!3m2!1sen!2sin!4v1689756698763!5m2!1sen!2sin"
            style={{
              width: "100%",
              height: "350px",
              border: 0,
              display: "block",
            }}
            allowFullScreen
            loading="lazy"
            title="Google Maps Location"
          />
        </div>
      </div>

      {/* Media Queries */}
      <style>
        {`
          /* PhoneInput theming */
          .PhoneInput {
            background: rgb(249 249 249);
          }
          .PhoneInputInput {
            background: rgb(249 249 249) !important;
          }
          .PhoneInputCountry,
          .PhoneInputCountrySelect {
            background: rgb(249 249 249) !important;
          }
          @media (max-width: 768px) {
            .contact-main-row {
              flex-direction: column;
            }
            .contact-image-col {
              display: none;
            }
            h2 { font-size: 22px !important; }
            form { padding: 0; }
          }
          @media (max-width: 500px) {
            .checkbox-box { min-width: auto; }
          }
        `}
      </style>
    </div>
  );
}

export { DiscussForm };
